import { useRef } from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams, useSearchParams, Outlet } from "react-router-dom"


// Questo è un middleware che contralla se l'utente ha il booleano isUserPurchaseAvailable è true, quindi è abilitato ad effettuare acquisti
const UserPurchaseDataCheck = () => {
    const { activityId } = useParams();
    const { isUserPurchaseAvailable } = useSelector(state => state.user);
    console.log('isUserPurchaseAvailable: ', isUserPurchaseAvailable)
    const hasNavigated = useRef(false);
    // Se l'utente è abilitato all'acquisto (dati acquisto inseriti (isAvailable)) navigo verso send-request
    // Altrimenti verso la pagina di inserimento dati di acquisto
    if (!hasNavigated.current) {
        if (activityId && !isUserPurchaseAvailable) {
            hasNavigated.current = true;
            return <Navigate to="/set-user-data" />
        }
    }
    return <Outlet />
}

export default UserPurchaseDataCheck